export default __webpack_public_path__ + "static/world_map-2a80026688a4bd16163d83702f432ce4.png";